export default __webpack_public_path__ + "static/media/post-drawing.439d1bd4.png";